export type GetDefaultFiltersParams<F extends Record<string, any>> = {
	filters?: Partial<F>;
	filterableFields: readonly (keyof F)[];
};

export const getDefaultFilters = <F extends Record<string, any>>({
	filters,
	filterableFields,
}: GetDefaultFiltersParams<F>): F => {
	return filterableFields.reduce<F>((accum, field) => {
		return {
			...accum,
			[field]: filters?.[field] ?? null,
		};
	}, {} as F);
};

export default getDefaultFilters;
